import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {SharedSettings} from '../models/shared-settings';
import {DateTime} from "luxon";
import {Observable} from "rxjs";
import {url} from "../helpers/url";
import {EmployeeQrCodeAssignment} from "../models/employee-qr-code-assignment";
import {ProductQrCodeAssignment} from "../models/product-qr-code-assignment";

@Injectable({
  providedIn: 'root'
})
export class QrCodeAssignmentService {

    constructor(private http: HttpClient,
                private settings: SharedSettings,) { }

    getEmployeeQrCodeAssignments(siteId: string, asOf?: DateTime): Observable<EmployeeQrCodeAssignment[]> {
        let dateString = asOf ? `&asOf=${asOf?.toISODate()}` : ''
        return this.http.get<EmployeeQrCodeAssignment[]>(this.settings.apiBaseUrl + url`qrCodeAssignment/employees?siteId=${siteId}` + dateString);
    }

    getProductQrCodeAssignments(siteId: string, asOf?: DateTime): Observable<ProductQrCodeAssignment[]> {
        let dateString = asOf ? `&asOf=${asOf?.toISODate()}` : ''
        return this.http.get<ProductQrCodeAssignment[]>(this.settings.apiBaseUrl + url`qrCodeAssignment/products?siteId=${siteId}` + dateString);
    }

    createEmployeeQrCodeAssignment(assignment: Omit<EmployeeQrCodeAssignment, 'id'>, invalidateExisting: boolean = false): Observable<EmployeeQrCodeAssignment> {
        return this.http.post<EmployeeQrCodeAssignment>(this.settings.apiBaseUrl + url`qrCodeAssignment/employees?invalidateExisting=${invalidateExisting}`, {...assignment, startDate: assignment.startDate.toISODate()});
    }

    createProductQrCodeAssignment(assignment: ProductQrCodeAssignment): Observable<ProductQrCodeAssignment> {
        return this.http.post<ProductQrCodeAssignment>(this.settings.apiBaseUrl + url`qrCodeAssignment/products`, {...assignment, startDate: assignment.startDate.toISODate()});
    }

    updateEmployeeQrCodeAssignment(assignment: EmployeeQrCodeAssignment): Observable<EmployeeQrCodeAssignment> {
        return this.http.put<EmployeeQrCodeAssignment>(this.settings.apiBaseUrl + url`qrCodeAssignment/employees/${assignment.id}`, JSON.stringify(assignment.endDate.toISODate()), {
            headers: { 'Content-Type': 'application/json' }
        });
    }

    updateProductQrCodeAssignment(assignment: ProductQrCodeAssignment): Observable<ProductQrCodeAssignment> {
        return this.http.put<ProductQrCodeAssignment>(this.settings.apiBaseUrl + url`qrCodeAssignment/products/${assignment.id}`, JSON.stringify(assignment.endDate.toISODate()), {
            headers: { 'Content-Type': 'application/json' }
        });
    }
}
